import clsx from "clsx";
import type { ScheduleHealth } from "@shared/types";
import { HEALTH_META } from "@/lib/format";
import { useLookups } from "@/lib/lookups";

export function HealthBadge({ health, className }: { health: ScheduleHealth; className?: string }) {
  const m = HEALTH_META[health];
  return (
    <span className={clsx("chip", className)} style={{ background: m.bg, color: m.color }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: m.color }} />
      {m.label}
    </span>
  );
}

export function StatusBadge({ value }: { value: string }) {
  const { byCategory } = useLookups();
  const row = byCategory("status").find((l) => l.value === value) || byCategory("project_status").find((l) => l.value === value);
  const color = row?.color || "rgb(var(--ink-faint))";
  return (
    <span className="chip" style={{ background: `${color}22`, color }}>
      {row?.label || value}
    </span>
  );
}

export function PriorityDot({ value }: { value: string }) {
  const color = { Critical: "#c0392b", High: "#e08a1e", Medium: "#3f7d5c", Low: "#94948c" }[value] || "#94948c";
  return (
    <span className="inline-flex items-center gap-1.5 text-xs">
      <span className="h-2 w-2 rounded-full" style={{ background: color }} />
      {value}
    </span>
  );
}
